<template>
  <div
    class="open22"
    :class="{ more_projects_available: more_projects_available }"
  >
    <div class="inner-shadow"></div>
    <f-sexy-scroll visible>
      <div class="title">
        <h1>{{$vt('Open existing project')}}</h1>
      </div>
      <div class="content">
        <div class="v17-panel">
          <div class="search">
            <f-icon class="f-icon" icon="fa6-magnifying-glass"></f-icon>
            <input
              @click.stop=""
              @input="doSearch()"
              type="search"
              v-model.trim="search"
              :placeholder="$vt('Search')"
            />
            <button
              v-if="search"
              v-on:click.stop="
                search = '';
                doSearch();
              "
            >
              <f-icon class="f-icon" icon="fa6-xmark"></f-icon>
            </button>
          </div>
          <div class="open22-table">
            <div class="open22-table-head">
              <div class="open22-table-row">
                <div
                  class="open22-table-cell sortable c-title"
                  :class="{ selected: sort === 'name' }"
                  v-on:click="sortBy('name')"
                >
                  {{$vt('Name')}}
                  <f-icon
                    class="sortable-icon"
                    v-if="'name' == sort"
                    :icon="sortInverted ? 'fa6-chevron-up' : 'fa6-chevron-down'"
                  >
                  </f-icon>
                </div>

                <div
                  class="open22-table-cell sortable c-date"
                  :class="{ selected: sort === 'date' }"
                  v-on:click="sortBy('date')"
                >
                  {{$vt('Date')}}
                  <f-icon
                    v-if="'date' == sort"
                    class="sortable-icon"
                    :icon="sortInverted ? 'fa6-chevron-up' : 'fa6-chevron-down'"
                  >
                  </f-icon>
                </div>

                <div class="open22-table-cell c-type">{{$vt('Type')}}</div>
              </div>
            </div>
            <div
              v-if="
                !loading &&
                !search &&
                Object.keys(component.projects).length == 0
              "
              class="no_search_result"
            >
              <f-icon icon="fa6-circle-info"></f-icon>
              {{$vt('No Events yet')}}
            </div>
            <div
              v-if="
                !loading &&
                search &&
                Object.keys(component.projects).length == 0
              "
              class="no_search_result"
            >
              <f-icon icon="fa6-circle-info"></f-icon>
              {{$vt('No result found for')}} "{{ search }}"
            </div>
            <div
              class="open22-table-body"
              v-if="Object.keys(component.projects).length > 0"
            >
              <div v-if="loading" class="loading">
                <f-icon spin icon="fa6-circle-notch"></f-icon>
              </div>

              <Open21ProjectItem
                v-for="item in component.projects"
                :key="item['#id']"
                :component="item"
                :handler="handler"
                :selected="sort"
              ></Open21ProjectItem>
              <div
                class="open22-file-item-container"
                v-if="
                  more_projects_available &&
                  Object.keys(component.projects).length >= component.page_count
                "
              >
                <div
                  class="open22-file-item more"
                  @click="debouncedLoadmore()"
                  :class="{ pending: loading }"
                >
                  <span v-if="!loading">
                    {{$vt('Load more')}} <f-icon icon="fa6-arrow-down"></f-icon>
                  </span>
                  <span v-if="loading">
                    <f-icon spin icon="fa6-circle-notch"></f-icon>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="new">
        <vue-placeholder
          :component="component.create"
          :handler="handler"
          :data="{type:'secondary'}"
        ></vue-placeholder>
      </div>
    </f-sexy-scroll>
  </div>
</template>

<script>
import Open21ProjectItem from "./Open21ProjectItem.vue";
import Open21Autoscroll from "./Open21Autoscroll.vue";

import { debounce } from "../utils/debounce.mjs";

import "./Open22.scss";

export default {
  translate25Context: 'vconsole17_vue.open21',
  methods: {
    async sortBy(prop) {
      if (this.sort == prop) {
        this.sortInverted = !this.sortInverted;
      } else {
        this.sort = prop;
      }

      // this.loading = true;
      await this.handler.action(this.component["#id"], "sort_by", [
        this.sort,
        !this.sortInverted ? "asc" : "desc",
      ]);
      // this.loading = false;
      console.info("sort... OK");
    },
    async loadMore() {
      console.info("loadmore....");
      this.loading = true;
      await this.handler.action(this.component["#id"], "load_more");
      this.loading = false;
      const load_more_result = await this.handler.action(
        this.component["#id"],
        "can_i_load_more"
      );

      this.more_projects_available = !!(
        load_more_result && load_more_result["#result"]
      );

      console.info(
        "loadmore... OK, more project available",
        this.more_projects_available
      );
    },
  },
  props: ["component", "handler"],
  components: { Open21ProjectItem, Open21Autoscroll /* , FSexyScroll */ },
  data: function () {
    return {
      sort: "date",
      sortInverted: true,
      search: "",
      loading: false,
      more_projects_available: true,
    };
  },
  computed: {},
  created() {
    this.doSearch = debounce(() => {
      this.handler.action(this.component["#id"], "set_search", [this.search]);
    }, 250);

    this.debouncedLoadmore = debounce(
      () => {
        console.info("debounced loadmore");
        if (!this.loading) {
          return this.loadMore();
        }
      },
      100,
      true
    );
  },
  mounted() {
    // initializing
    this.debouncedLoadmore();
  },
};
</script>